import type { BehaviorSegmentType } from 'types/api/diagnosisReportRefResponseType';
import { formatNumberToCurrency, formatRateToPercent } from 'utils/app';

import type { JSX } from 'react';

function SegmentTable(props: { title: string; segments: BehaviorSegmentType[] }): JSX.Element {
  const { title, segments } = props;

  return (
    <div className="col-lg-6">
      <h5 className="title-section title-sm">{title}</h5>
      <table className="vcr-table">
        <thead>
          <tr>
            <th>区分</th>
            <th>到達</th>
            <th>完了</th>
            <th>完了率</th>
          </tr>
        </thead>
        <tbody>
          {segments.map(segment => (
            <tr key={segment.label}>
              <td>{segment.label}</td>
              <td>{formatNumberToCurrency(segment.reachedCount)}</td>
              <td>{formatNumberToCurrency(segment.completedCount)}</td>
              <td>
                <div className="behavior-bar-track">
                  <div
                    className="behavior-segment-bar-fill"
                    style={{ width: `${formatRateToPercent(segment.completionRate)}%` }}
                  />
                </div>
                {formatRateToPercent(segment.completionRate)}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/**
 * デバイス・ブラウザ別完了率表示コンポーネント（EV-report-analytics-04）。
 */
export default function WsReportSegmentCompletion(props: {
  devices: BehaviorSegmentType[];
  browsers: BehaviorSegmentType[];
}): JSX.Element | null {
  const { devices, browsers } = props;
  if (devices.length === 0 && browsers.length === 0) return null;

  return (
    <div className="card card-white behavior-analytics-card">
      <div className="card-body">
        <h4 className="title-section title-sm">デバイス・ブラウザ別完了率</h4>
        <div className="row">
          <SegmentTable title="デバイス" segments={devices} />
          <SegmentTable title="ブラウザ" segments={browsers} />
        </div>
        <p className="behavior-analytics-note">
          判定はブラウザが送る User-Agent に基づく推定です。
        </p>
      </div>
    </div>
  );
}
